<p class="text-start">{{formatedInfo()}}</p>